<template>
    <div class="flex w-full flex-col gap-y-4">
        <div class="flex w-full justify-between">
            <div class="flex flex-col">
                <span
                    class="text-lg font-medium"
                    v-text="data.name"
                />
                <span
                    class="text-muval-gray-2 -mt-1 text-base font-medium"
                    v-text="$filters.capitalize(data.type)"
                />
            </div>
            <Lozenge
                :class="[textStyle, bgStyle]"
                class="mt-1"
                >{{ $filters.capitalize(data.status) }}</Lozenge
            >
        </div>
        <img
            v-if="data.logo_url"
            :src="data.logo_url"
            class="h-16 w-fit"
        />
        <div class="flex flex-col">
            <span class="font-medium">Contact info</span>
            <span v-text="data.email" />
            <span v-text="data.phone" />
        </div>
        <div
            v-if="data.review_rating && data.review_count"
            class="rounded-muval-1 bg-muval-gray-6 flex w-fit grow-0 items-center gap-x-1 border px-1 py-0.5 text-xs"
        >
            <SvgIcon
                name="system-star"
                class="text-muval-amber mr-0.5 h-4 w-4"
            />
            <span
                class="leading-4 font-medium"
                v-text="data.review_rating"
            />
            <span
                class="text-muval-gray-2 text-xs leading-4"
                v-text="data.review_count"
            />
        </div>
    </div>
</template>
<script setup>
const props = defineProps({
    data: {
        type: Object,
        required: true,
    },
});

const { textStyle, bgStyle } = useStatusColours(props.data.status, { type: 'company' });
</script>
